import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { paginationStyles } from "@insite/content-library/Widgets/ProductList/ProductListPagination";
import { css } from "styled-components";

paginationStyles.pagination = mergeToNew(paginationStyles.pagination, {
    cssOverrides: {
        pagination: css`
            padding: 9px 18px;
        `,
        perPageSelect: css`
            [class^="FormFieldStyle"] {
                width: auto;
                > label {
                    width: auto;
                    font-size: 14px;
                    font-weight: 400;
                    padding: 4px 10px 0 0;
                }
                > [class^="FormInputWrapper"] {
                    width: auto;
                    select {
                        border-radius: 6px !important;
                        height: 28px;
                        font-size: 14px;
                    }
                    > [class^="IconWrapper"] {
                        padding: 0px 8px 12px 8px;
                    }
                }
            }
        `,
        linkList: css`
            button {
                max-width: fit-content;
                white-space: nowrap;
                padding: 0px 6px;
                width: 32px;
                &:hover {
                    border: none !important;
                }
            }
        `,
    },
});
